export default __webpack_public_path__ + "static/media/place-type-fueling.3e1eaff4.svg";